import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../api';

import Header from '../../components/layout/Header';
import { Button } from '../../components/common/Button';
import { FormGroup, Label, Input, Select, Message, PhoneInputContainer } from '../../components/common/Forms';
import { AuthPageContainer, AuthFormCard, Title } from '../../components/common/AuthLayout';

function RequestDemoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    emailCorporativo: '',
    celular: '',
    cargo: '',
    siteEmpresa: '',
    numFuncionarios: ''
  });
  const [mensagem, setMensagem] = useState({ text: '', type: '' });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post(`/api/request-demo`, formData);
      setMensagem({ text: 'Obrigado! Sua solicitação foi enviada. Entraremos em contato em breve.', type: 'success' });
      // Limpar o formulário ou redirecionar para uma página de "obrigado"
    } catch (error) {
      setMensagem({
        text: error.response?.data?.error || 'Ocorreu um erro ao enviar sua solicitação.',
        type: 'error'
      });
    }
  };

  return (
    <>
      <Header />
      <AuthPageContainer>
        <AuthFormCard>
          <Title>Fale com um Especialista</Title>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Primeiro Nome*</Label>
              <Input name="nome" value={formData.nome} onChange={handleChange} required />
            </FormGroup>
            
            <FormGroup>
              <Label>E-mail corporativo*</Label>
              <Input name="emailCorporativo" type="email" value={formData.emailCorporativo} onChange={handleChange} required placeholder="email@empresa.com.br" />
            </FormGroup>

            <FormGroup>
                <Label>Celular*</Label>
                <PhoneInputContainer>
                    <Select defaultValue="br">
                        <option value="br">Brasil (+55)</option>
                        {/* Adicionar outros países se necessário */}
                    </Select>
                    <Input name="celular" value={formData.celular} onChange={handleChange} required />
                </PhoneInputContainer>
            </FormGroup>

            <FormGroup>
              <Label>Qual é o seu cargo?*</Label>
              <Select name="cargo" value={formData.cargo} onChange={handleChange} required>
                <option value="" disabled>Selecione</option>
                <option value="socio">Sócio(a)/Fundador(a)</option>
                <option value="diretor">Diretor(a)</option>
                <option value="gerente">Gerente</option>
                <option value="analista">Analista</option>
                <option value="outro">Outro</option>
              </Select>
            </FormGroup>

             <FormGroup>
                <Label>Qual o site da sua empresa?*</Label>
                <Input name="siteEmpresa" value={formData.siteEmpresa} onChange={handleChange} required placeholder="www.exemplo.com.br" />
            </FormGroup>
            
            <Button type="submit" style={{ width: '100%' }}>Enviar</Button>
          </form>
          {mensagem.text && <Message type={mensagem.type}>{mensagem.text}</Message>}
        </AuthFormCard>
      </AuthPageContainer>
    </>
  );
}

export default RequestDemoPage;